import { registerFeatureWithDescription } from "lib/features"

// Renamed from id "scenario-planner" pre-launch (FIQ-2130), so the derived demand key is
// "feature-optimiser". Internal environments that ticked the old flag need it re-ticked on
// the Features screen after deploy. See OPTIMISER-NAMING.md for the full naming map.
export const FEATURE_FLAG_OPTIMISER = registerFeatureWithDescription({
    numericalId: 3000,
    id: "optimiser",
    name: "Optimiser",
    readyForProduction: true,
    descriptionLines: ["Enables Optimiser for scenario modelling, rate cards, rule sets, and what-if analysis"],
})
